import React from 'react'
import styled from 'react-emotion'

const Wrapper = styled('div')`
  text-align: center;
  padding: 10px;
  img {
    width: auto !important;
    min-height: auto !important;
    max-height: ${props => props.small ? '35px' : '55px'};
    max-width: ${props => props.small ? '35px' : '55px'};
  }
`

export default ({ title, small = false, ...props }) => (
  <div {...props}>
    <Wrapper small={small} className="loader-container">
      <img src="/cdn/img/customer/loader-tui-blue.gif" alt="loader" />
      {title && <h3>{title}</h3>}
    </Wrapper>
  </div>
)